import React, { useEffect, useState } from 'react';
import EditorString from '../EditorString/EditorString';
import {
  WishListActions,
  WishListProps,
  shareListAsMail,
} from '../../Reducers/WishList.reducer';
import ProductCard from '../ProductCards/ProductCard';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { translate } from '../../Services/translation';
import Toggler from '../Toggler';
import { useDispatch } from 'react-redux';
import Icon from '../Icon';
import SideMenu from '../SideMenu/SideMenu';
import TextArea from '../Inputs/TextArea';
import Input from '../Inputs/Input';
import { ShareStatus } from '../../Reducers/WishList.reducer';
import LoadingSpinner from '../LoadingSpinner';
import { useTypedDispatch } from '../../Hooks/useTypedDispatch';
import PatternImageToggler from '../FilterBar/PatternImageToggler';

const WishList = () => {
  const {
    items,
    description,
    title,
    id,
    shareUri,
    shareModal,
    shareStatus,
  } = useTypedSelector((state) => state.wishList);

  const { showRoomImage } = useTypedSelector(
    (state) => state.productListing
  );

  const [showCheckmark, setShowCheckmark] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<String>();
  const [email, setEmail] = useState<String>();
  const dispatch = useTypedDispatch();

  const copyShareLink = () => {
    if (shareUri) {
      setShowCheckmark(true);
      navigator.clipboard.writeText(shareUri);
      setTimeout(() => setShowCheckmark(false), 2500);
    }
  };

  const onSubmit = () => {
    if (email) {
      dispatch(
        shareListAsMail({
          email: email,
          message: message ?? '',
          shareUri: shareUri ?? '',
        })
      ).finally(() =>
        setTimeout(
          () => dispatch(WishListActions.resetshareStatus({})),
          2500
        )
      );
    }
  };

  return (
    <>
      <SideMenu
        className="z-50 rounded"
        id={id}
        open={modalOpen}
        onClosed={() => setModalOpen(false)}
        contentClassName="px-7"
      >
        {shareModal && (
          <div className="mt-4 flex flex-col">
            {shareModal?.title && (
              <h3 className="mb-2">{shareModal.title}</h3>
            )}
            {shareModal?.description && (
              <p className="mb-6">{shareModal.description}</p>
            )}
            <TextArea
              inputSize="large"
              className="mb-4 rounded-md"
              placeholder={translate('wish-list.message')}
              onChange={(e) => setMessage(e.target.value)}
            />
            <Input
              className="mb-4 rounded-md"
              inputSize="large"
              placeholder={translate('wish-list.mail')}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button
              className="h-14 cursor-pointer items-center justify-center gap-2 rounded-md border border-solid bg-gray-700 px-4 text-center text-sm font-normal uppercase text-white"
              onClick={onSubmit}
            >
              {shareStatus === ShareStatus.none &&
                translate('wish-list.submit')}
              {shareStatus === ShareStatus.pending && <LoadingSpinner />}
              {shareStatus === ShareStatus.fulfilled && (
                <Icon
                  name="check"
                  color="text-white"
                  className="h-4 w-4"
                />
              )}
              {shareStatus === ShareStatus.rejected && (
                <Icon
                  name="close"
                  color="text-white"
                  className="text-white-500 h-4 w-4"
                />
              )}
            </button>
          </div>
        )}
      </SideMenu>
      <div className="border-b border-gray-100">
        <div className="container">
          <div className="mb-6 max-w-[568px]">
            {title && <h1>{title}</h1>}
            {description?.value && (
              <EditorString value={description.value} />
            )}
          </div>
          {shareUri && (
            <div className="mb-10 flex flex-row gap-4 md-down:flex-col">
              <button
                className="flex w-[168px] cursor-pointer items-center justify-center gap-2 rounded-md border border-solid border-gray-700 px-4 py-2 text-center text-sm font-normal uppercase md-down:w-full"
                onClick={copyShareLink}
              >
                {showCheckmark && translate('wish-list.copied')}
                <Icon
                  name={showCheckmark ? 'check' : 'document'}
                  className="h-5 w-5"
                />
                {!showCheckmark && translate('wish-list.copy')}
              </button>
              <button
                className="flex w-[168px] cursor-pointer items-center justify-center gap-2 rounded-md border border-solid border-gray-700 px-4 py-2 text-center text-sm font-normal uppercase md-down:w-full"
                onClick={() => setModalOpen(true)}
              >
                <Icon name="mail" className="h-5 w-5" />
                {translate('wish-list.share-mail')}
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="container mb-10">
        <div className="my-3 flex items-center justify-between">
          <div className="text-sm uppercase text-gray-500">
            {items?.length} {translate('general.products').toLowerCase()}
          </div>
          <PatternImageToggler />
        </div>
        <div className="grid grid-cols-4 gap-4 md-down:grid-cols-2">
          {items?.map((item) => {
            return (
              <ProductCard
                key={item.id}
                product={item.product}
                showRoomshot={showRoomImage}
                showPatternImage={!showRoomImage}
              />
            );
          })}
        </div>
      </div>
    </>
  );
};

export default WishList;
